import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check authentication status on mount
  useEffect(() => {
    const authStatus = sessionStorage.getItem('hawkai_auth');
    const username = sessionStorage.getItem('hawkai_user');
    
    if (authStatus === 'true' && username) {
      setIsAuthenticated(true);
      setUser({ username });
    }
    setLoading(false);
  }, []);

  const login = () => {
    const username = sessionStorage.getItem('hawkai_user');
    setIsAuthenticated(true);
    setUser({ username });
  };

  const logout = () => {
    sessionStorage.removeItem('hawkai_auth');
    sessionStorage.removeItem('hawkai_user');
    setIsAuthenticated(false);
    setUser(null);
  };

  const value = {
    isAuthenticated,
    user,
    loading,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

